/* ReportingLines.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./ReportingLines.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { cx } from '@atlaskit/css';
import { fg } from '@atlaskit/platform-feature-flags';
import { Box } from '@atlaskit/primitives/compiled';
var styles = {
  reportingLinesSection: "_18u01b66 _19pku2gc",
  managerSection: "_1e0c1txw _4cvr1h6o _18u01b66 _19pk1b66 _otyr1b66 _2hwx1b66",
  managerName: "_11c81o8v _18u0u2gc",
  offsetWrapper: "_19pk1b66 _18u0r5cr"
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/use-primitives -- Ignored via go/DSP-18766
var ReportingLinesSectionLegacy = styled.div({
  // Minor left margin to align better with existing icon fields
  marginLeft: "var(--ds-space-050, 4px)",
  marginTop: "var(--ds-space-100, 8px)"
});
export var ReportingLinesSection = function ReportingLinesSection(_ref) {
  var children = _ref.children;
  return fg('compiled-migration-profilecard') ? /*#__PURE__*/React.createElement(Box, {
    xcss: cx(styles.reportingLinesSection)
  }, children) : /*#__PURE__*/React.createElement(ReportingLinesSectionLegacy, null, children);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
var ManagerSectionLegacy = styled.div({
  display: 'flex',
  alignItems: 'center',
  margin: "var(--ds-space-050, 4px)".concat(" ", "var(--ds-space-050, 4px)")
});
export var ManagerSection = function ManagerSection(_ref2) {
  var children = _ref2.children;
  return fg('compiled-migration-profilecard') ? /*#__PURE__*/React.createElement(Box, {
    xcss: cx(styles.managerSection)
  }, children) : /*#__PURE__*/React.createElement(ManagerSectionLegacy, null, children);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
var ManagerNameLegacy = styled.span({
  font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
  marginLeft: "var(--ds-space-100, 8px)"
});
export var ManagerName = function ManagerName(_ref3) {
  var children = _ref3.children;
  return fg('compiled-migration-profilecard') ? /*#__PURE__*/React.createElement(Box, {
    xcss: cx(styles.managerName)
  }, children) : /*#__PURE__*/React.createElement(ManagerNameLegacy, null, children);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/use-primitives -- Ignored via go/DSP-18766
var OffsetWrapperLegacy = styled.div({
  marginTop: "var(--ds-space-050, 4px)",
  // Offset left margin so the avatar aligns with the heading
  marginLeft: "var(--ds-space-negative-050, -4px)"
});
export var OffsetWrapper = function OffsetWrapper(_ref4) {
  var children = _ref4.children;
  return fg('compiled-migration-profilecard') ? /*#__PURE__*/React.createElement(Box, {
    xcss: cx(styles.offsetWrapper)
  }, children) : /*#__PURE__*/React.createElement(OffsetWrapperLegacy, null, children);
};